
import { axiosGet, axiosPost } from "../../../react_axios/Axios";
import { SUBMIT_COMBINE_DELEGATE_FORM, getDelegatePreviewDetailsUrl, GET_DELEGATE_PREVIEW_DETAILS, delegaterRegistrationCombineSubmitUrl, headers, GET_DELEGATE_BADGE_ACTION_TYPE, deleteVisaDocDelegateUrl, DELETE_VISA_DOC_DELEGATE, getDelegateFieldListUrl, GET_DELEGATE_FIELD_LIST_ACTION_TYPE } from "../../../utils/constants";

export const delegateRegistrationCombineSubmit_action = (AccountID, DelegateRegistrationID, CountryID, AccountTypeID, PersonIncharge_Title, PersonIncharge_FirstName,
    PersonIncharge_LastName, PersonIncharge_GenderID, PersonIncharge_Designation, CompanyName, GSTNo, PanNo, IECCode, Address1, Address2, Address3, Website, MobileNo,
    WhatsappMobileNo, IsSameMobileNo, State, City, Pin, PrimaryEmail, Telephone, Telephone1, CompanyProfile, CompanyWebsite, TotalOperationalYears, CompanyTurnOverID,
    ArrivalDate, DepartureDate, IsCoordinator, isCoordinatorAsDelegate, IsIntrestedForB2B, isVisaAssistance, NameOnPassport, ApplicantEmailID, ApplicantMobileNo,
    PassportNo, PassportIssueDate, PassportExpiryDate, PassportIssuingCountryID, PassportFilePath, PassportFile, PassportFileName, PassportFileType, industrySegmentMappingList,
    purposeofVisitList, daysList, interestSeminarList, hallChapterList, B2BMeetingList, ISAgree, flag, PersonProfile, PersonPhoto, PersonPhotoData, PersonPhotoName, PersonPhotoType, DelegateRegistrationNo, ExhProgramList, ExhProgramDateList, ExhProgramCategory) => async (dispatch) => {
        try {
            const mapdata = {
                UserID: (sessionStorage.getItem('DelegateDataSS')) != null ? JSON.parse(sessionStorage.getItem('DelegateDataSS')).UserID : "",
                AccountID: flag == true ? JSON.parse(sessionStorage.getItem('SelectedDelegateDataSS')).AccountID : JSON.parse(sessionStorage.getItem('loginDataSS')).AccountID,
                DelegateRegistrationID: flag == true ? JSON.parse(sessionStorage.getItem('SelectedDelegateDataSS')).DelegateRegistrationID : JSON.parse(sessionStorage.getItem('DelegateDataSS')).DelegateRegistrationID,
                ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
                CountryID: CountryID,
                AccountTypeID: AccountTypeID,
                PersonIncharge_Title: PersonIncharge_Title,
                PersonIncharge_FirstName: PersonIncharge_FirstName,
                PersonIncharge_LastName: PersonIncharge_LastName,
                PersonIncharge_GenderID: PersonIncharge_GenderID,
                PersonIncharge_Designation: PersonIncharge_Designation,
                CompanyName: CompanyName,
                GSTNo: GSTNo,
                PanNo: PanNo,
                IECCode: IECCode,
                Address1: Address1,
                Address2: Address2,
                Address3: Address3,
                Website: Website,
                MobileNo: MobileNo,
                WhatsappMobileNo: WhatsappMobileNo,
                IsSameMobileNo: IsSameMobileNo,
                State: State,
                City: City,
                Pin: Pin,
                PrimaryEmail: PrimaryEmail,
                Telephone: Telephone,
                Telephone1: Telephone1,
                CompanyProfile: CompanyProfile,
                CompanyWebsite: CompanyWebsite,
                TotalOperationalYears: TotalOperationalYears,
                CompanyTurnOverID: CompanyTurnOverID,
                ArrivalDate: ArrivalDate,
                DepartureDate: DepartureDate,
                IsCoordinator: isCoordinatorAsDelegate,
                isCoordinatorAsDelegate: isCoordinatorAsDelegate,
                IsIntrestedForB2B: IsIntrestedForB2B,
                isVisaAssistance: isVisaAssistance,
                NameOnPassport: NameOnPassport,
                ApplicantEmailID: ApplicantEmailID,
                ApplicantMobileNo: ApplicantMobileNo,
                PassportNo: PassportNo,
                PassportIssueDate: PassportIssueDate,
                PassportExpiryDate: PassportExpiryDate,
                PassportIssuingCountryID: PassportIssuingCountryID,
                PassportFilePath: PassportFile,
                PassportFile: PassportFile,
                PassportFileName: PassportFileName,
                PassportFileType: PassportFileType,

                industrySegmentMappingList: industrySegmentMappingList,
                purposeofVisitList: purposeofVisitList,
                daysList: daysList,
                interestSeminarList: interestSeminarList,
                hallChapterList: hallChapterList,
                B2BMeetingList: B2BMeetingList,
                ISAgree: ISAgree,
                PersonProfile: PersonProfile,
                PersonPhoto: PersonPhoto,
                PersonPhotoData: PersonPhotoData,
                PersonPhotoName: PersonPhotoName,
                PersonPhotoType: PersonPhotoType,
                DelegateRegistrationNo: DelegateRegistrationNo,
                ExhProgramList: ExhProgramList,
                ExhProgramDateList: ExhProgramDateList,
                ExhProgramCategory: ExhProgramCategory
                // visitDaysList: list
            }
            console.log("visitorRegistrationNext_action--------->", mapdata)
            const res = await axiosPost(delegaterRegistrationCombineSubmitUrl, mapdata, headers);
            dispatch({
                type: SUBMIT_COMBINE_DELEGATE_FORM,
                payload: res,
            });
            return Promise.resolve(res);
        } catch (err) {
            return Promise.reject(err);
        }
    };

export const getDelegateCombineDetails_action = (flag, selectedVisitorID) => async (dispatch) => {
    var VisitorTypeIDUserID = sessionStorage.getItem('DelegateTypeID') == 10 && ((JSON.parse(sessionStorage.getItem('DelegateDataSS')).UserIDs).split(','))[0]
    try {
        const param = {
            UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            AccountID: selectedVisitorID ? selectedVisitorID : flag == true ? JSON.parse(sessionStorage.getItem('SelectedDelegateDataSS')).AccountID : JSON.parse(sessionStorage.getItem('DelegateDataSS')).AccountID,
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
            DelegateRegistrationID: flag == true ? JSON.parse(sessionStorage.getItem('SelectedDelegateDataSS')).DelegateRegistrationID : JSON.parse(sessionStorage.getItem('DelegateDataSS')).DelegateRegistrationID
        }

        const res = await axiosGet(getDelegatePreviewDetailsUrl, param, headers);
        dispatch({
            type: GET_DELEGATE_PREVIEW_DETAILS,
            payload: res,
        });
        console.log("getVisitorPreviewDetails_action--------->", param)
        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const deleteVisaDoc_action = (flag, accountID, DelegateRegistrationID) => async (dispatch) => {

    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            AccountID: flag == true ? JSON.parse(sessionStorage.getItem('SelectedDelegateDataSS')).AccountID : JSON.parse(sessionStorage.getItem('loginDataSS')).AccountID,
            DelegateRegistrationID: flag == true ? JSON.parse(sessionStorage.getItem('SelectedDelegateDataSS')).DelegateRegistrationID : JSON.parse(sessionStorage.getItem('DelegateDataSS')).DelegateRegistrationID
        }
        console.log("Delete deleteExhibitorBadge_ Document Action---------------->", params)
        const res = await axiosGet(deleteVisaDocDelegateUrl, params, headers)
        dispatch({
            type: DELETE_VISA_DOC_DELEGATE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getDelegateFirldList_action = (DelegateType) => async (dispatch) => {
    // var VisitorTypeIDUserID = sessionStorage.getItem('DelegateTypeID') == 10 && ((JSON.parse(sessionStorage.getItem('DelegateDataSS')).UserIDs).split(','))[0]
    try {
        const param = {
            UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            // AccountID: DelegateType == 10 ? JSON.parse(sessionStorage.getItem('DelegateDataSS')).AccountIDs : JSON.parse(sessionStorage.getItem('DelegateDataSS')).AccountID,
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
            AccountTypeID: DelegateType
        }

        const res = await axiosGet(getDelegateFieldListUrl, param, headers);
        dispatch({
            type: GET_DELEGATE_FIELD_LIST_ACTION_TYPE,
            payload: res,
        });
        console.log("getVisitorPreviewDetails_action--------->", param)
        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};